import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { Modal } from 'react-bootstrap';

import CopyBlack from "@/assets/icons/copyBlack.png"
import BlackCross from "@/assets/icons/blackCross.png"
import Share01 from "@/assets/icons/share01.png"

import "./style.css"
import { useState } from 'react';
import { toast } from 'sonner';
import { useSafeAreaInsets } from '@/hooks/useSafeAreaInsets';

function VideoShareModal(props: any) {
    const { common } = useLocalTranslation();
    const { bottomSafeComponent } = useSafeAreaInsets();
    const handleCopy = () => {
        if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(props.urlToShare)
                .then(() => {
                    // console.log("Copied to clipboard!")
                    toast.success(common.statusText.urlCoped)
                    setTimeout(() => {
                        props.handleClose('close')
                    }, 300)
                })
                .catch((err) => {
                    console.log("Failed to copy: " + err)
                });
        } else {
            console.log("Failed to copy")
        }
    };

    return (
        <Modal
            className='videoShareModal01'
            show={props.show}
            onHide={() => props.handleClose('close')}
            keyboard={true}
            centered={window.innerWidth > 500}>

            <div className='videoShareModal p-[20px]'>

                <Modal.Header className='p-0 border-0 mb-[10px] modalHeader'>
                    <Modal.Title className='text-[16px] font-bold'>
                        {common.statusText.share}
                    </Modal.Title>
                    <img
                        className='cursor-pointer blackCross'
                        onClick={() => props.handleClose('close')}
                        src={BlackCross}
                        alt='BlackCross' />
                </Modal.Header>

                <Modal.Body className='p-0'>
                    {/* <p className='text-[14px] text-green-700 mb-[4px] ml-[4px] font-semibold'>
                        {handleCopyText}
                    </p> */}
                    <div className='modalBody'>
                        <div className='urlCon'>
                            <p className='url'>
                                {props.urlToShare}
                            </p>
                            <img
                                onClick={handleCopy}
                                className='cursor-pointer copyIcon'
                                src={CopyBlack} alt='CopyBlack' />
                        </div>
                        <img
                            className='share01'
                            src={Share01} alt='share01' />
                    </div>
                </Modal.Body>
                {bottomSafeComponent}
            </div>
        </Modal>
    );
}

export default VideoShareModal;